module.exports = __webpack_public_path__ + "static/media/HCMM605.874a2817.jpg";